import Vue from "vue";
import App from "./App.vue";
import {
  router
} from "./router";
import iView from "iview";
import locale from 'iview/dist/locale/en-US'
import "iview/dist/styles/iview.css";
import VueWorker from "vue-worker";
import config from "./config";

import "./css/bootstrap.min.css";
import "./css/style.css";

import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap/dist/css/bootstrap.css';

Vue.use(BootstrapVue);

const Feathers = require("@feathersjs/feathers");
const socketio = require("@feathersjs/socketio-client");
const io = require("socket.io-client");
const socket = io(config.default.socketURI);

const feathers = Feathers();
feathers.configure(socketio(socket));

socket.on("connect", function () {
  console.log("Socket connected!");
});
socket.on("disconnect", function () {
  console.log("Socket disconnected!");
});

const vueFeathers = require("vue-feathers");
Vue.use(vueFeathers, feathers);

Vue.use(iView, { locale });

Vue.use(VueWorker);

// console.log('DomainKey :::: ', process.env.VUE_APP_DOMAINKEY)
// console.log('DomainKey :::: ', process.env.VUE_APP_ACCESSKEY)
// console.log('DomainKey :::: ', process.env.VUE_APP_SECRETKEY)
// console.log(process.env.VUE_APP_SERVERKEY + "/process");

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");